import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import SideBarItemList from './SideBarItemList';
import SolarClipboardCheckOutline from '../icons/SolarClipboardCheckOutline';
import SolarCalendarLinear from '../icons/SolarCalendarLinear';
import SolarNotesLinear from '../icons/SolarNotesLinear';
import useSettingsParams from 'hooks/useSettingsParams';
import { useAuth } from 'context/AuthContext';
import { canManageTaskDir } from 'utils/helpers/access/hasUserAccess';

export type SideBarTasksProps = {
    variant?: 'manager' | 'team';
};

const SideBarTasks = ({ variant = 'manager' }: SideBarTasksProps) => {
    const { t } = useTranslation();
    const location = useLocation();
    const params = useSettingsParams();
    const { auth } = useAuth();
    const canViewTasks = !!params.tasksModule;

    if (!canViewTasks) return null;

    if (variant === 'team') {
        const boardActive = location.pathname === '/tasks';
        const calendarActive = location.pathname === '/tasks/calendar';

        return (
            <>
                <li className={`pc-item ${boardActive ? 'active' : ''}`}>
                    <Link className="pc-link hide-sidebar" to="/tasks">
                        <span className="pc-micon pc-micon--tasks">
                            <SolarClipboardCheckOutline />
                        </span>
                        <span className="pc-mtext">{t('SideBar4Team.titleTasksBoard')}</span>
                    </Link>
                </li>
                <li className={`pc-item ${calendarActive ? 'active' : ''}`}>
                    <Link className="pc-link hide-sidebar" to="/tasks/calendar">
                        <span className="pc-micon pc-micon--tasks">
                            <SolarCalendarLinear />
                        </span>
                        <span className="pc-mtext">{t('SideBar4Team.titleTasksCalendar')}</span>
                    </Link>
                </li>
            </>
        );
    }

    const canManageDir = canManageTaskDir(auth?.user);

    return (
        <SideBarItemList
            title={t('SideBarUl.itemTasks')}
            icon={<SolarClipboardCheckOutline />}
            iconClass="pc-micon--tasks"
            itemsList={[
                {
                    label: t('SideBarUl.itemTasksBoard'),
                    to: '/tasks',
                    icon: <SolarClipboardCheckOutline />,
                },
                {
                    label: t('SideBarUl.itemTasksCalendar'),
                    to: '/tasks/calendar',
                    icon: <SolarCalendarLinear />,
                },
                ...(canManageDir
                    ? [
                          {
                              label: t('SideBarUl.itemTasksProcesses'),
                              to: '/tasks/processes',
                              icon: <SolarClipboardCheckOutline />,
                          },
                      ]
                    : []),
                ...(canManageDir
                    ? [
                          {
                              label: t('SideBarUl.itemTasksDir'),
                              icon: <SolarNotesLinear />,
                              children: [
                                  {
                                      label: t('SideBarUl.itemTasksDirTasks'),
                                      to: '/tasks/dir',
                                  },
                                  {
                                      label: t('SideBarUl.itemTasksDirProcesses'),
                                      to: '/tasks/process-dir',
                                  },
                              ],
                          },
                      ]
                    : []),
            ]}
        />
    );
};

export default SideBarTasks;
